import { Reveal } from "./Reveal";
import { Divider, Paisley, Vine } from "../HennaMotif";

export const Details = () => (
  <section
    id="detaylar"
    data-testid="details-section"
    className="relative overflow-hidden py-32 md:py-48"
  >
    <Paisley className="pointer-events-none absolute -left-10 top-40 h-56 w-44 rotate-12 text-henna/20" />

    <div className="mx-auto max-w-7xl px-6 md:px-10">
      <Reveal className="mb-24 max-w-3xl">
        <p className="mb-6 font-sans text-xs uppercase tracking-[0.35em] text-gold">
          Nurhan &amp; Emre
        </p>
        <h2 className="font-serif text-4xl leading-[1.05] tracking-tight text-cream md:text-6xl lg:text-7xl">
          Sizleri bu özel gecemizde
          <span className="italic text-gold"> aramızda </span>
          görmekten mutluluk duyarız.
        </h2>
        <Vine className="mt-8 h-8 w-64 max-w-full text-gold/50" />
      </Reveal>

      <Reveal className="mx-auto max-w-4xl text-center" data-testid="quote-block">
        <p className="mb-8 font-sans text-xs uppercase tracking-[0.4em] text-gold">
          Nurhan &amp; Emre
        </p>
        <div className="relative">
          <span className="pointer-events-none absolute -left-2 -top-10 select-none font-serif text-8xl leading-none text-gold/50 md:-left-8 md:text-9xl">
            &ldquo;
          </span>
          <p className="font-serif text-5xl italic leading-[1.05] tracking-tight text-cream md:text-7xl lg:text-8xl">
            Sen en büyük şükrümsün.
          </p>
          <span className="pointer-events-none ml-2 select-none align-bottom font-serif text-6xl leading-none text-gold/50 md:text-7xl">
            &rdquo;
          </span>
        </div>
      </Reveal>

      <Reveal className="mt-24" data-testid="henna-note">
        <div className="mx-auto max-w-2xl border-y border-gold/30 bg-surface/40 px-8 py-8 text-center">
          <p className="mb-3 font-sans text-xs uppercase tracking-[0.35em] text-gold">
            Küçük Bir Not
          </p>
          <p className="font-serif text-2xl italic leading-snug text-cream md:text-3xl">
            Düğün akşamımızın son bir saatinde
            <span className="text-gold"> kına </span>
            gerçekleştirilecektir.
          </p>
        </div>
      </Reveal>

      <Reveal className="mt-20">
        <Divider />
      </Reveal>
    </div>
  </section>
);
